import { NylasListMessagesRequestContent, NylasListMessagesResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to list messages for a Nylas connection
 * @param request Message list parameters (connectionId, filters, pagination)
 * @returns Promise with list of messages and pagination info
 */
export const listIntegrationMessagesApi = async (request: NylasListMessagesRequestContent): Promise<NylasListMessagesResponseContent> => {
  const apiRequest = createApiRequest<NylasListMessagesResponseContent>('post', '/integrations/nylas/messages/list');
  return apiRequest(request);
};
